var videoOptions = {
    fill: true,
    fluid: true,
    responsive: true,
    preload: "auto",
    controls: true,
    controlBar: {
        volumePanel: { inline: false },
        skipButtons: {
            forward: 10,
            backward: 10
        }
    },
    html5: {
        vhs: {
            enableLowInitialPlaylist: false,
            overrideNative: true,
            withCredentials: true
        }
    },
    playbackRates: [0.5, 1, 1.5, 2],
    sourceOrder: true
};
export default videoOptions;
//# sourceMappingURL=videoOptions.js.map